import React from 'react'
import PanelContainer from 'containers/panel/customer/panel-container'

const MainPage = () => {
  return (
    <PanelContainer />
  )
}

export default MainPage